<div class="gl3-page">

  <!-- Toolbar -->
  <div class="gl3-toolbar">
    <button mat-icon-button class="gl3-filter-btn" (click)="openSetGameFilterDialog()" aria-label="Filter games">
      <mat-icon>filter_alt</mat-icon>
    </button>

<!--     <div class="gl3-toggle-group">
      <button class="gl3-toggle-btn" [class.active]="!pastGamesActive()" (click)="getData()">
        <mat-icon>event</mat-icon>
        {{ 'GAMES.COMING' | translate }}
      </button>
      <button class="gl3-toggle-btn" [class.active]="pastGamesActive()" (click)="getPastGames()">
        <mat-icon>event_repeat</mat-icon>
        {{ 'GAMES.PAST' | translate }}
      </button>
    </div> -->
    <button mat-icon-button  (click)="getPastGames()" aria-label="Past games">
      <mat-icon>event_repeat</mat-icon>
      
    </button>
     <button mat-icon-button class="gl3-refresh-btn" (click)="getData()" aria-label="Upcoming games">
      <mat-icon>event_upcoming</mat-icon>
    </button>

    <button mat-button class="gl3-tz-btn" [matMenuTriggerFor]="timezoneMenu" aria-label="Select timezone">
      <mat-icon>schedule</mat-icon>
      {{ (GroupByPropertyName() === 'GameTimeUTC' ? 'TIMEZONE.MY_TIMEZONE' : 'TIMEZONE.LOCAL_TIMEZONES') | translate }}
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #timezoneMenu="matMenu">
      <button mat-menu-item (click)="toggleTimezone('GameTimeUTC')">{{ 'TIMEZONE.MY_TIMEZONE' | translate }}</button>
      <button mat-menu-item (click)="toggleTimezone('GameDate')">{{ 'TIMEZONE.LOCAL_TIMEZONES' | translate }}</button>
    </mat-menu>
  </div>

  <div class="gl3-filter-panel">
    <mat-form-field appearance="outline" class="gl3-filter-text-field">
      <mat-label>Team</mat-label>
      <input matInput
             [value]="pendingFilterText()"
             (input)="pendingFilterText.set($any($event.target).value || '')"
             (keydown.enter)="$event.preventDefault(); applyTeamFilter()"
             placeholder="Enter team name and press Enter">
    </mat-form-field>
  </div>

  @if (activeFilters().length > 0) {
    <div class="gl3-active-filters">
      <mat-chip-set aria-label="Active team filters">
        @for (filter of activeFilters(); track filter.id) {
          <mat-chip-row (removed)="removeFilter(filter.id)">
            {{ filter.value }}
            <button matChipRemove aria-label="Remove filter value">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-set>

      <button mat-button class="gl3-clear-filters-btn" (click)="clearFilters()">
        Clear all
      </button>
    </div>
  }

  <!-- Progress / states -->
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate" class="gl3-progress"></mat-progress-bar>
    <div class="gl3-state-msg">{{ 'GENERAL.LOADING' | translate }}…</div>
  }
  @if (_pageData().Games.length === 0 && !isLoading()) {
    <div class="gl3-state-msg">{{ 'GAMES.NOGAMESFOUND' | translate }}</div>
  }

  <!-- Game list -->
  @if (_pageData().Games.length > 0) {
    <div class="gl3-content">
      @for (group of _pageData().Games | groupByDateAndDivision: GroupByPropertyName() : useLocalTimezone(): sort(); track group.GroupDate) {

        <!-- Date header -->
        <div class="gl3-date-header">
          <span class="gl3-date-day">{{ group.GroupDate | date: 'dd' }}</span>
          <span class="gl3-date-month">{{ group.GroupDate | date: 'MMM' }}</span>
          <span class="gl3-date-weekday">{{ group.GroupDate | date: 'EEEE' }}</span>
        </div>

        @for (division of group.Divisions; track division.DivisionName) {
          <!-- Division label -->
          <div class="gl3-division-label">{{ division.DivisionName }}</div>

          <!-- Game rows -->
          @for (game of division.Games; track game.GameId) {
            <a class="gl3-game-row" [routerLink]="['/scouting/gamedetails', game.GameId]">

              <!-- Home team -->
              <div class="gl3-team gl3-team--home">
                <span class="gl3-team-name">{{ game.HomeTeamName || '—' }}</span>
                <img class="gl3-team-logo"
                     [src]="getIconPath(game.HomeTeamSmallIcon)"
                     fallbackIcon="gpp_maybe"
                     alt="Home Team">
              </div>

              <!-- Kickoff time -->
              <div class="gl3-kickoff">
                {{ (GroupByPropertyName() === 'GameTimeUTC' ? game.GameTimeUTC : game.GameTime) | date: 'HH:mm' }}
              </div>

              <!-- Away team -->
              <div class="gl3-team gl3-team--away">
                <img class="gl3-team-logo"
                     [src]="getIconPath(game.AwayTeamSmallIcon)"
                     fallbackIcon="gpp_maybe"
                     alt="Away Team">
                <span class="gl3-team-name">{{ game.AwayTeamName || '—' }}</span>
              </div>

              <!-- Schedule action -->
              <button class="gl3-schedule-btn" mat-icon-button
                      (click)="$event.preventDefault(); $event.stopPropagation(); addToSchedule(game.GameId, game.HomeTeamName, game.AwayTeamName, game.GameDate, game.GameTime)"
                      aria-label="Add to schedule">
                <mat-icon>today</mat-icon>
              </button>

            </a>
          }
        }
      }
    </div>
  }

</div>